export const brand = {
  name: "Gobierno Municipal de Piribebuy",
  shortName: "Gobierno Municipal",
  descriptor: "Orgullo que nos une",
  motto: "Orgullo que nos une",
  academyName: "Academia Municipal",
  municipality: "Piribebuy",
} as const;

